import { isNilAndToThousandSeparator } from '@shared/utils/webHelper'
import { pathOr } from 'ramda'
import styled from 'styled-components'

export const TabPane = styled.div`
  display: flex;
  margin-left: -24px;
  margin-top: -24px;
  border-top-left-radius: 8px;

  .tab__item {
    width: 240px;
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    border-top: 6px solid #c0c0c0;
    font-size: 16px;
    font-weight: 500;
    color: #c0c0c0;
    cursor: pointer;
    transition: 0.3s;

    &:first-child {
      border-top-left-radius: 8px;
    }

    &:hover {
      background: #f4f3f3;
    }

    &.is--active,
    &:hover {
      border-top-color: ${p => p.theme.primary};
      color: ${p => p.theme.primary};
    }
  }
`

export const TabContainer = styled.div`
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  min-height: calc(100vh - 112px);
`

export const StatusWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex: 1;
  min-height: 56px;
  height: auto;
  border-radius: 4px;
  margin: 25px 10px 0 0;
  padding: 0 10px;
  color: #fff;
  border: 1px solid #20e4ff;
  background: linear-gradient(
    180deg,
    rgba(52, 232, 242, 0) 0%,
    rgba(52, 232, 242, 0.5) 100%
  );

  span {
    white-space: nowrap;
  }
`

type StatusBoxProps = {
  title: string
  unit?: string
  data: any
  value?: number
  dataKey: string
  detail?: {
    title: string
    value?: number
    dataKey?: string
  }[]
}

export const StatusBox = ({
  title,
  unit,
  data = [],
  dataKey,
  value,
  detail,
}: StatusBoxProps) => {
  // const validData = Array.isArray(data) ? data : []
  // const _v = value || sum(pluck(`${dataKey}`, validData))
  const _v = pathOr('-', [dataKey], data)

  return (
    <StatusWrapper>
      <div className="flex h-full gap-5 py-2">
        <div>
          <div>
            <span
              style={{
                fontSize: '12px',
                color: '#20E4FF',
              }}>
              {title}
            </span>
            {unit && (
              <span
                style={{
                  fontSize: '12px',
                  color: '#FFFFFF',
                  marginLeft: '5px',
                }}>
                / {unit}
              </span>
            )}
          </div>
          <div>{isNilAndToThousandSeparator(_v)}</div>
        </div>
        {detail && (
          <>
            <div className="w-1 h-full bg-[#20e4ff]" />
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: 8,
              }}>
              {detail.map((d, index) => {
                // const _dv = d.value || sum(pluck(`${d.dataKey}`, validData))
                const _dv = pathOr('-', [dataKey], data)

                return (
                  <div className="h-full flex items-center" key={index}>
                    <span style={{ color: '#20E4FF', marginRight: '5px' }}>
                      {d.title}
                    </span>
                    <span>{isNilAndToThousandSeparator(_dv)}</span>
                  </div>
                )
              })}
            </div>
          </>
        )}
      </div>
    </StatusWrapper>
  )
}
